import React, {Component} from 'react';
// import ReactPlaceholder from 'react-placeholder';
// import 'nprogress/nprogress.css';
// import 'react-placeholder/lib/reactPlaceholder.css';
import CircularProgress from "../components/CircularProgress/index";

export default function asyncComponent(importComponent, component_props) {
    const LazyComponent = React.lazy(importComponent);

    class AsyncFunc extends Component {
        render() {
            return (
                <React.Suspense fallback={<CircularProgress/>}>
                    <LazyComponent {...this.props} {...component_props}/>
                </React.Suspense>
            )
        }
    }

  return AsyncFunc;
}
